import Vue from 'vue';

export default filter => Vue.$http
    .get('Orders', { params: filter });




// WEBPACK FOOTER //
// ./src/services/order/get.js